import React from 'react'
import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import Select from 'react-select'

import useViewModel from './ViewModel'

const PileExecutedStatusChangerView: React.FC = () => {
  const { modalsRoot, open, status, options, onSubmit, onChangeStatus, onClose } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_project_pile_execution_attachment'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={open}
      onHide={onClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>เปลี่ยนสถานะของรายการเสา</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body'>
          <Select
            value={options.find(o => o.value === status) ?? null}
            options={options}
            placeholder='เลือกสถานะ'
            onChange={(e: any) => {
              if (e) onChangeStatus(e?.value)
            }}
            styles={{
              menu: (provided: any) => ({ ...provided, zIndex: 9999 }),
            }}
          />
        </div>

        <div className='modal-footer'>
          <button className='btn btn-sm btn-secondary me-4' type='button' onClick={onClose}>
            ปิด
          </button>
          <button className='btn btn-sm btn-success' type='button' onClick={onSubmit}>
            ยืนยัน
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default PileExecutedStatusChangerView
